import { initializeApp, getApps } from "firebase/app";
import {
  getMessaging,
  isSupported,
  Messaging,
  onMessage,
} from "firebase/messaging";
import { firebaseConfig } from "./config/firebaseConfig";

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

let messagingPromise: Promise<Messaging | null> | null = null;

export const getFirebaseMessaging = async () => {
  if (!messagingPromise) {
    messagingPromise = isSupported()
      .then((supported) => (supported ? getMessaging(app) : null))
      .catch(() => null);
  }
  return messagingPromise;
};

export const subscribeToForegroundMessages = async (
  callback: Parameters<typeof onMessage>[1]
) => {
  const messaging = await getFirebaseMessaging();
  if (!messaging) {
    console.warn("Firebase messaging is not supported in this browser.");
    return () => {};
  }
  return onMessage(messaging, callback);
};

